document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.flower-container');
  const paletteSquares = document.getElementById('palette-squares');

  let animationState = 0;
  let randomAnimationInterval;
  let petalsAnimationTimeout;
  let hoverDelay;
  let paletteMousemoveListener;

  const colors = [
    '#FF4949', '#FF7043', '#FFAB40', '#FFD54F', '#FFF176', 
    '#DCE775', '#AED581', '#81C784', '#4DB6AC', '#4DD0E1', 
    '#4FC3F7', '#64B5F6', '#7986CB', '#9575CD', '#BA68C8', 
    '#F06292', '#FF8A80', '#FFD180', '#FFE57F', '#FFFF8D', 
    '#CCFF90', '#B9F6CA', '#A7FFEB', '#84FFFF', '#80D8FF'
  ];

  function createPalette() {
    paletteSquares.innerHTML = '';
    colors.forEach(color => {
      const square = document.createElement('div');
      square.className = 'color-square';
      square.style.backgroundColor = color;
      square.dataset.color = color;
      paletteSquares.appendChild(square);
    });
  }

  function animateRandomSquares() {
    const squares = document.querySelectorAll('.color-square');
    return setInterval(() => {
      squares.forEach(sq => {
        sq.style.transform = 'scale(1)';
        sq.style.boxShadow = 'none';
        sq.style.zIndex = '1';
      });

      const randomIndex = Math.floor(Math.random() * squares.length);
      const square = squares[randomIndex];
      square.style.transform = 'scale(1.5)';
      square.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
      square.style.zIndex = '10';
    }, 500);
  }

  function handleMousemove(e) {
    const squares = document.querySelectorAll('.color-square');
    squares.forEach(square => {
      const sqRect = square.getBoundingClientRect();
      const sqCenter = {
        x: sqRect.left + sqRect.width / 2,
        y: sqRect.top + sqRect.height / 2
      };

      const distance = Math.sqrt(
        Math.pow(e.clientX - sqCenter.x, 2) + 
        Math.pow(e.clientY - sqCenter.y, 2)
      );

      const maxDist = 50;
      if (distance < maxDist) {
        const scale = 1 + (1 - distance / maxDist) * 0.7;
        square.style.transform = `scale(${scale})`;
        square.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
        square.style.zIndex = '10';
      } else {
        square.style.transform = 'scale(1)';
        square.style.boxShadow = 'none';
        square.style.zIndex = '1';
      }
    });
  }

  function resetFlowerAnimation() {
    animationState = 0;
    container.classList.remove('flower-active');
    paletteSquares.style.opacity = '0';
    paletteSquares.style.transform = 'translate(-50%, -50%) scale(0)';

    clearTimeout(petalsAnimationTimeout);
    clearInterval(randomAnimationInterval);

    if (paletteMousemoveListener) {
      paletteSquares.removeEventListener('mousemove', paletteMousemoveListener);
    }
  }

  container.addEventListener('mouseenter', () => {
    hoverDelay = setTimeout(() => {
      if (animationState === 0) {
        clearTimeout(petalsAnimationTimeout);
        clearInterval(randomAnimationInterval);

        container.classList.add('flower-active');
        animationState = 1;

        petalsAnimationTimeout = setTimeout(() => {
          if (animationState === 1) {
            paletteSquares.style.opacity = '1';
            paletteSquares.style.transform = 'translate(-50%, -50%) scale(1)';
            randomAnimationInterval = animateRandomSquares();

            paletteMousemoveListener = handleMousemove;
            paletteSquares.addEventListener('mousemove', paletteMousemoveListener);

            paletteSquares.addEventListener('mouseenter', () => {
              clearInterval(randomAnimationInterval);
              randomAnimationInterval = null;
            });

            paletteSquares.addEventListener('mouseleave', () => {
              if (!randomAnimationInterval) {
                randomAnimationInterval = animateRandomSquares();
              }
            });
          }
        }, 600);
      }
    }, 150);
  });

  container.addEventListener('mouseleave', () => {
    clearTimeout(hoverDelay);
    resetFlowerAnimation();
  });

  createPalette();
});
